import { Routes, Route, Navigate } from 'react-router-dom';

import { Layout, Header } from 'common/components';

import LoginFeature from './features/login';
import RegistrationFeature from './features/registration';
import ForgottenPasswordFeature from './features/forgotten-password';

function AuthFeature() {
  return (
    <Layout>
      <Header />
      <Layout.Content>
        <Layout.Container>
          <Routes>
            <Route path="login" element={<LoginFeature />} />
            <Route path="registration" element={<RegistrationFeature />} />
            <Route path="forgotten-password/*" element={<ForgottenPasswordFeature />} />
            <Route path="*" element={<Navigate to="../login" replace />} />
          </Routes>
        </Layout.Container>
      </Layout.Content>
    </Layout>
  );
}

export default AuthFeature;
